if (!customElements.get('faq-list')) {
  class FaqList extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const summary = e.target.closest('summary');
        if (!summary) return;

        const item = summary.closest('details');

        // Animate-close all other open items
        this.querySelectorAll('details[open]').forEach((el) => {
          if (el !== item) this.#animateClose(el);
        });

        // If this item is open, animate close instead of instant toggle
        if (item.open) {
          e.preventDefault();
          this.#animateClose(item);
        }
        // If closed, let browser open it — CSS transition handles the expand
      });
    }

    #animateClose(item) {
      const answer = item.querySelector('.faq__item-answer');
      if (!answer) {
        item.removeAttribute('open');
        return;
      }

      item.classList.add('faq__item--closing');
      answer.style.gridTemplateRows = '0fr';
      answer.addEventListener(
        'transitionend',
        () => {
          item.removeAttribute('open');
          item.classList.remove('faq__item--closing');
          answer.style.gridTemplateRows = '';
        },
        { once: true }
      );
    }
  }

  customElements.define('faq-list', FaqList);
}
